export default __webpack_public_path__ + "static/media/bg.db11e1d7.png";